<template>
    <v-dialog :value="value" @click:outside="close" :width="defaultDialogWidth" persistent>
        <v-card>
            <div class="px-6 py-4 d-flex justify-space-between">
                <h5 class="title">Анализ платежеспособности</h5>
                <v-btn @click="close" icon>
                    <v-icon small>fas fa-times</v-icon>
                </v-btn>
            </div>
            <v-card-text>
                <validation-observer ref="scoringObs" v-slot="{handleSubmit}">
                    <form @submit.prevent="handleSubmit(startScoring)">
                        <v-row>
                            <v-col cols="7" class="py-0">
                                <custom-input-text
                                        label="Сумма"
                                        name="Сумма"
                                        rules="required"
                                        v-model="scoringData.amount"
                                        vid="amount">
                                </custom-input-text>
                            </v-col>
                            <v-col cols="5" class="py-0">
                                <custom-select
                                        :items="percents"
                                        item-text="text"
                                        item-value="value"
                                        label="Процент"
                                        name="Процент"
                                        rules="required"
                                        v-model="scoringData.percent"
                                        vid="percent"
                                ></custom-select>
                            </v-col>
                        </v-row>
                        <v-btn :loading="loading" color="primary" type="submit" width="100%">Анализ</v-btn>
                    </form>
                </validation-observer>
                <div v-if="showInfo" class="mt-3">
                    <h3 class="mb-2 title" style="font-size: initial!important;" v-if="bank">Банк: {{bank}}</h3>
                    <h3 class="title" style="font-size: initial!important" v-if="user">ФИО: {{user}}</h3>
                    <v-list>
                        <v-list-item :key="item.id"
                                     class="pa-0"
                                     v-for="item in analysis">
                            <v-progress-circular
                                    color="primary"
                                    indeterminate
                                    size="20"
                                    v-if="loading"
                                    width="2"
                            ></v-progress-circular>
                            <template v-else>
                                <v-icon class="success pa-1 circle-radius" color="#fff" style="width: 25px; height: 25px;" v-if="item.success"
                                        x-small>fas fa-check
                                </v-icon>
                                <v-icon class="error pa-1 circle-radius" color="#fff" style="width: 25px; height: 25px;" v-else x-small>
                                    fas fa-times
                                </v-icon>
                            </template>
                            <span class="d-inline-block ml-2">{{item.text}}</span>
                        </v-list-item>
                    </v-list>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
	import {GET_PERCENTS, defaultDialogWidth} from "@/utils/constants";
	import {AnalysisCard} from "@/utils/AnalysisCard";

	export default {
		name: "ScoringByToken",
		props: {
			value: {
				type: Boolean
			},
			user_card_id: {
				type: Number
            },
			amount: {},
			initial: {},
      firstPayment: null
		},
		data() {
			return {
				loading: false,
				percents: GET_PERCENTS(),
				analysis: [],
				showInfo: false,
				bank: null,
				user: null,
				scoringData: {
					amount: null,
					percent: "50",
					user_card_id: null
				},
				defaultDialogWidth
			}
		},
		methods: {
			async startScoring() {
				try {
					this.loading = true;
					this.scoringData.amount = this.scoringData.amount.toString();
					const {data: {data}} = await this.$http.post('admin/scoring/by-token', this.scoringData)
					const analysisCard = new AnalysisCard(data)
					analysisCard.parseData()
					this.analysis = analysisCard.results.map(item => {
						return {
							text: `Проверки за ${item.date} по ${this.scoringData.percent}%`,
							success: item.value
						}
					})
					this.bank = analysisCard.bank
					this.user = analysisCard.user
					this.loading = false;
					this.showInfo = true;
				} catch (e) {
					this.loading = false
					this.$setResponseError({error: e})
					this.$setFormError({error: e, obs: this.$refs['scoringObs']})
				}
			},
			close() {
				this.showInfo = false;
				this.$refs.scoringObs.reset()
				this.$emit('input', false)
			},
		},
        watch: {
          firstPayment: function (val) {
                this.scoringData.amount = val
			},
            user_card_id: function (val) {
                this.scoringData.user_card_id = val
			}
        },
		created() {
			this.scoringData.amount = this.firstPayment
			this.scoringData.user_card_id = this.user_card_id
		}
	}
</script>

<style scoped>

</style>
